module.exports = __webpack_public_path__ + "static/media/11-romulo-leitao.3105e9c3.webp";